import {create} from 'zustand';

interface GeneralSettings {
  site_name: string;
}

interface AppSettingStore {
  loaded: boolean;
  setLoaded: (loaded: boolean) => void;
  generalSettings: GeneralSettings;
  setGeneralSettings: (general: GeneralSettings) => void;
}

const useAppSettingStore = create<AppSettingStore>(set => ({
  loaded: false,
  setLoaded(loaded: boolean) {
    set({loaded});
  },
  generalSettings: {
    site_name: 'Entiz',
  },
  setGeneralSettings(generalSettings: GeneralSettings) {
    set({generalSettings});
  },
}));

export default useAppSettingStore;
